"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    // Colors
    bgColorBrandPrimary: '#E5E5E5',
    colorBrandPrimary: '#2e128b',
    indigo1: '#2E058D',
    indigo2: '#4B35D2',
    indigo3: '#5246F7',
    indigo4: '#586FEF',
    indigoPastel1: '#867EF9',
    indigoPastel2: '#E1DEFF',
    indigoPastel3: '#EEEDFD',
    teal1: '#30CECA',
    teal2: '#6BEDD8',
    grey1: '#34323A',
    grey2: '#736F7F',
    grey3: '#8F8B9B',
    grey4: '#B4B1BD',
    grey5: '#D0CED5',
    grey6: '#E5E3EB',
    grey7: '#ECEBF2',
    grey8: '#F2F1F5',
    grey9: '#FBFBFB',
    greyTable: '#F8F8F8',
    warningRed: '#E8544D',
    cautionOrange: '#F5A125',
    cautionOrangeDark: '#E59113',
    validGreen: '#54C063',
    validGreenDark: '#41AF50',
    white1: '#FFFFFF',
    // Shadows
    indigoShadow1: '0px 3px 20px rgba(75, 53, 210, 0.1)',
    indigoShadow2: '0px 3px 20px rgba(75, 53, 210, 0.2)',
    indigoShadowLight: '0px 3px 20px rgba(75, 53, 210, 0.05)',
    indigoShadowHover: '0px 10px 25px rgba(75, 53, 210, 0.25)',
    redShadow1: '0px 3px 20px rgba(232, 84, 77, 0.2)',
    // Disabled Colors Mapping
    disabled: {
        indigo3: '#9790FA',
        grey3: '#BCB9C3',
        warningRed: '#F19894'
    },
    // fixed sizes used across clients
    headerHeight: '70px'
};
//# sourceMappingURL=globalStyle.js.map